import React from 'react';
import PickupOption from './pickup-option';
import ShipToHomeOption from './ship-to-home-option';
import ExpressOption from './express-option';
// import './sass/tiles.scss';

function Fulfillments({
  selectedOption,
  select,
  pickupDetails,
  shippingDetails,
  expressDetails,
  fulfillmentDetails,
  showLiveGoods
}) {
  const { doHideForNotifyMe, proInstallSelected } = fulfillmentDetails;

  if((doHideForNotifyMe || pickupDetails.limitedStockInventoryRestricted) && !showLiveGoods){
    return doHideForNotifyMe && !showLiveGoods && (
      <div
        className="fulfillment-tiles card-deck"
        style={{display: proInstallSelected?'none':'flex'}}
      >
        <PickupOption
          selected={selectedOption==='PICKUP'}
          select={select}
          details={pickupDetails}
          fulfillmentDetails={fulfillmentDetails}
        />
        <ShipToHomeOption
          fulfillmentDetails={fulfillmentDetails}
          selected={selectedOption==='STH'}
          select={select}
          details={shippingDetails}
        />
        <ExpressOption
          selected={selectedOption==='EXPRESS'}
          select={select}
          details={expressDetails}
          fulfillmentDetails={fulfillmentDetails}
        />
      </div>
    );
  }else{
    return null;
  }
}

export default Fulfillments;
